import * as Yup from 'yup';

export const addressValidationSchema = Yup.object().shape({
  countryCode: Yup.string().nullable().required('Country is required'),
  locality: Yup.string().required('City is required'),
  addressLine1: Yup.string().required('Street address is required'),
  addressLine2: Yup.string(),
  administrativeArea: Yup.string().required('State is required'),
  postalCode: Yup.string()
    .required('Zip code is required')
    .when('countryCode', {
      is: 'US',
      then: (schema) => schema.matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Must be 5 or 9 digits'),
    }),
});
